import { fmtType } from '../segments/segmentTypes';
import { pagesRange } from '../segments/cutChild';

// Left rail in the viewer: the documents inside this file. Click one to jump to
// its first page; the one under the reader's eye is highlighted. Navigation
// only — no state chips (plan §7d). A "?" marks a boundary the detector was not
// sure about; the file's own warnings (truncated, failed readings) sit at the foot.
export default function SegmentsRail({ segments, activePage, onJump, warnings = [], unsurePages = [] }) {
  if (!segments || segments.length <= 1) return null;
  const activeIdx = segments.findIndex((s) => activePage >= s.page_start && activePage <= s.page_end);
  return (
    <nav className="dv-doc-rail" aria-label="Documents in this file">
      <div className="dv-doc-rail-head">
        <span>Documents in this file</span>
        <span className="dv-doc-rail-count">{segments.length}</span>
      </div>
      {(warnings.length > 0 || unsurePages.length > 0) && (
        <div className="seg-warn dv-doc-rail-warn">
          <span>⚠</span>
          <span>
            {warnings.map((w) => w.text).join(' · ')}
            {warnings.length > 0 && unsurePages.length > 0 ? ' · ' : ''}
            {unsurePages.length > 0 ? `Not sure about ${unsurePages.length} — marked ?` : ''}
          </span>
        </div>
      )}
      <ol className="dv-doc-rail-list">
        {segments.map((s, i) => (
          <li key={s.page_start} className={`dv-doc-rail-item${i === activeIdx ? ' is-active' : ''}`}>
            <button type="button" onClick={() => onJump?.(s.page_start)} title={s.anchor || ''}>
              <span className="dv-doc-rail-idx">{i + 1}</span>
              <span className="dv-doc-rail-body">
                <span className="dv-doc-rail-title">
                  {s.unsure && <span className="seg-unsure" title="The detector was not sure a document starts here">?</span>}{s.unsure ? ' ' : ''}
                  {s.title || fmtType(s.doc_type) || 'untitled'}
                </span>
                <span className="dv-doc-rail-meta">
                  {pagesRange(s.page_start, s.page_end)}
                  {s.doc_type && s.title ? ` · ${fmtType(s.doc_type)}` : ''}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ol>
      <div className="dv-doc-rail-foot">Not right? Click the divider above a page to move or merge it, or hover any page for “Document starts here”.</div>
    </nav>
  );
}
